import type { QueryKey } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { SynchronousQueryConfig } from 'lib/react-query';
import queryString from 'query-string';
import { apiClient } from 'lib/api';
import type { UserRole } from '../constants';
import type { Permission } from 'types/shared';

interface ResponseMe {
  apps: string[];
  permissions: Permission[];
  auth: boolean;
  email: string;
  username: string;
  first_name: string;
  last_name: string;
  hotjar_init: boolean;
  role?: UserRole.USER | UserRole.STAFF | UserRole.SUPERUSER;
}

export const getMe = async (signal?: AbortSignal): Promise<ResponseMe> => {
  const res = await apiClient.get<ResponseMe>(`/api/v1/user/me`, {
    signal,
    paramsSerializer: (prms) =>
      queryString.stringify(prms, { arrayFormat: 'comma' }),
  });

  return {
    ...res.data,
    permissions: [...(res?.data?.permissions ?? [])],
  } as ResponseMe;
};

interface UseUsersListOptions {
  config?: SynchronousQueryConfig<typeof getMe, ResponseMe>;
}

export const useMe = ({ config }: UseUsersListOptions = {}) => {
  return useQuery({
    staleTime: 60 * 30 * 1000,
    retry: false,
    ...config,
    queryFn: ({ signal }) => getMe(signal),
    queryKey: ['api', 'v1', 'user', 'me'] as QueryKey,
  });
};
